
let formData = {
  'items': []
};

let queries = [];
let variantData = {};
const colorVariantChangeEvent = new Event("colorVariantChange");

(() => {
  let paymentItems = document.querySelectorAll('.payment-item [data-popup]');
  paymentItems.forEach((element) => {
    let popUpId = element.getAttribute('data-popup');
    element.addEventListener('click', () => {
      let e = document.getElementById(popUpId);
      if(e.style.display === "block") {
        e.style.display = "none";
      } else {
        e.style.display = "block";
      }
    });
  });
})();

if(typeof productHandles !== 'undefined') {
  for (i in productHandles) {
    queries.push(window.Shopify.routes.root + 'products/' + productHandles[i] + '.js');
  }

  try {
    Promise.all(queries.map(u => fetch(u))).then(responses =>
      Promise.allSettled(responses.map(res => {
        return res.json();
      }))
    ).then(data => {
      let colorVariants = [];

      for(i in data) {
        if(data[i].status == 'fulfilled') {
          colorVariants.push(data[i].value);
        }
      }

      addColorVariantSwatches(colorVariants);
    });
 } catch {
    throw Error("query for variants failed");
  }
}

let stars = document.getElementById('star-rating');
let reviews = document.getElementById('total-reviews');
let starContainer = document.getElementById('tlf-star-reviews-container');
fetch('https://api.yotpo.com/products/nV0XhEI36DEX5xuuKQav17AyvLlidQlyGDH2XtWp/' + initialProductId + '/bottomline').then(response => response.json()).then(data => {
  let average = 0;
  let total = 0;

  if(data.status.code == 200){
    average = data.response.bottomline.average_score;
    total = data.response.bottomline.total_reviews;
  }

  reviews.innerHTML = total;

  let i = 0;
  for (const star of stars.children) {
    if(i < average) {
      star.classList.add('fill');
    }
    i++;
  }
});
starContainer.addEventListener('click', () => {
  window.scrollTo(0, document.querySelector('.yotpo-display-wrapper').offsetTop);
});

let appBanner = document.getElementById('app-exclusive-desktop');
if(appBanner) {
  appBanner.addEventListener('click', () => {
    let qrCode = document.getElementById('app-qr-code');
    fullSizeMedia(qrCode);
  });
}

sizeCharts(initialProductId);
oosNotification(productObject);

function oosNotification(product) {
  let variants = product?.variants;
  let oos = false;
  let oosbutton = document.getElementById('oos-button');
  oosbutton.style.display = "none";
  oosbutton.replaceWith(oosbutton.cloneNode(true));

  for(let i = 0; i < variants.length; i++) {
    if(!variants[i].available) {
      oos = true;
      break;
    }
  }

  if(oos) {
    let button = document.getElementById('oos-button');
    button.style.display = "block";
    button.addEventListener('click', () => {
      let closeButton = document.createElement('div');
      closeButton.classList.add('close-full-size');
      closeButton.addEventListener('click', () => {
        let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
        while(deleteFullSizeContainer[0]){
          deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
        }
      });

      closeButton.appendChild(document.createTextNode('X'));
      let fullSizeContainer = document.createElement('div');
      fullSizeContainer.classList.add('full-size-container');
      fullSizeContainer.addEventListener('click', () => {
        let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
        while(deleteFullSizeContainer[0]){
          deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
        }
      });

      let oosForm = document.createElement('div');
      oosForm.addEventListener('click', (event) => {event.stopPropagation();});
      oosForm.classList.add('oos-form');

      let heading = document.createElement('div');
      heading.classList.add('oos-heading');
      heading.appendChild(document.createTextNode('Notify Me When Available'));
      oosForm.appendChild(heading);

      let oosVariantImage = document.createElement('img');
      oosVariantImage.classList.add('oos-img');
      oosVariantImage.src = `${product?.images[0]}&width=200`;
      oosForm.appendChild(oosVariantImage);

      let productName = document.createElement('div');
      productName.classList.add('oos-heading');
      productName.appendChild(document.createTextNode(product?.title));
      oosForm.appendChild(productName);

      let oosVariantContainer = document.createElement('div');
      oosVariantContainer.classList.add('oos-variant-container');
      for(let i = 0; i < variants.length; i++) {
        if(!variants[i].available) {
          let oosVariant = document.createElement('div');
          oosVariant.appendChild(document.createTextNode(variants[i].option2));
          oosVariant.classList.add('tlf-oos-size-variant');
          oosVariant.dataset.variantid = variants[i].id;
          oosVariant.dataset.productid = product.id;
          oosVariant.dataset.listid = `oos_${product?.handle.replaceAll('-', '_')}_${variants[i]?.option2}`;
          oosVariant.name = variants[i].name;
          oosVariant.addEventListener('click', (event) => {
            event.stopPropagation();
            let = selectedVariant = variants[i];
            let alloosSizes = document.getElementsByClassName('tlf-oos-size-variant');
            for(let i = 0; i < alloosSizes.length; i++) {
              if(alloosSizes[i].classList.contains('active-size')){
                alloosSizes[i].classList.toggle('active-size');
              }
            }
            oosVariant.classList.add('active-size');
          });

          oosVariantContainer.appendChild(oosVariant);
        }
      }
      oosForm.appendChild(oosVariantContainer);

      let emailField = document.createElement('input');
      emailField.id = "oos-email";
      emailField.classList.add('oos-email');
      emailField.setAttribute('placeholder', 'Email Address');
      oosForm.appendChild(emailField);

      let validationField = document.createElement('div');
      validationField.classList.add('oos-validation');
      oosForm.appendChild(validationField);

      let notifyMeButton = document.createElement('div');
      notifyMeButton.appendChild(document.createTextNode('Notify Me'));
      notifyMeButton.classList.add('notify-me-button');
      notifyMeButton.addEventListener('click', () => {
        let email = document.getElementById("oos-email").value === "" ? false : document.getElementById("oos-email").value;
        let selectedOos = document.querySelector('.tlf-oos-size-variant.active-size');
        let variantid = selectedOos ? selectedOos.dataset.variantid : false;
        let productid = selectedOos ? selectedOos.dataset.productid : false;
        let listid = selectedOos ? selectedOos.dataset.listid : false;

        while(validationField.firstChild) {
          validationField.removeChild(validationField.firstChild);
        }

        if(!email) {
          let emailValidation = document.createElement('div');
          emailValidation.appendChild(document.createTextNode('*Please enter an email address'));
          validationField.appendChild(emailValidation);
        }

        if(!(variantid && productid)) {
          let oosValidation = document.createElement('div');
          oosValidation.appendChild(document.createTextNode('*Please select a size'));
          validationField.appendChild(oosValidation);
        }

        if(email && variantid) {
          fetch(`https://tlf-server-2023-oxh3p.ondigitalocean.app/zaius/add-to-list/${listid.toLowerCase()}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              'Accept': '*/*',
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
              email: email
            })
          }).then(response => response.json()).then(async data => {
          });

          let thankyoucontainer = document.createElement('div');
          let thankyou = document.createElement('div');
          let thankyoumessage = document.createElement('div');

          thankyou.classList.add('thankyou');
          thankyou.appendChild(document.createTextNode('YOU ARE ON THE LIST!'));
          thankyoumessage.classList.add('thankyoumessage');
          thankyoumessage.appendChild(document.createTextNode(`We added you to the list! We will reach out if this item becomes available again.`));
          thankyoucontainer.appendChild(thankyou);
          thankyoucontainer.appendChild(thankyoumessage);

          while(oosForm.firstChild) {
            oosForm.removeChild(oosForm.firstChild);
          }

          let continueShopping = document.createElement('div');
          continueShopping.classList.add('continue-shopping');
          continueShopping.appendChild(document.createTextNode('Continue Shopping'));
          continueShopping.addEventListener('click', () => {
            let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
            while(deleteFullSizeContainer[0]){
              deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
            }
          });

          oosForm.appendChild(thankyoucontainer);
          oosForm.appendChild(continueShopping);
        }
      });
      oosForm.appendChild(notifyMeButton);

      let containerWrap = document.createElement('div');
      containerWrap.classList.add('full-size-container-wrap');
      containerWrap.appendChild(closeButton);
      containerWrap.appendChild(oosForm);
      fullSizeContainer.appendChild(containerWrap);
      document.body.appendChild(fullSizeContainer);
    });
  }
}

function updateProductPageState(variant) {
  document.dispatchEvent(colorVariantChangeEvent);

  oosNotification(variant);

  let available = variant.available;

  // enable/disable
  let disable_buy = false;
  let buy_button_text = 'APP EXCLUSIVE - DOWNLOAD THE APP';

  // notify me button
  let notify_me = document.getElementById('notify-me-button');
  notify_me.style.display = 'none';

  // update badges (from tags)
  let tags = variant.tags;
  let tag_container = document.getElementById('product-tag-container');
  while(tag_container.firstChild){
    tag_container.removeChild(tag_container.firstChild);
  }

  let mens_mesh_warning = document.getElementById('mens-mesh-warning');
  let athletic_fit_warning = document.getElementById('athletic-fit-warning');
  let womens_mesh_warning = document.getElementById('womens-mesh-warning');
  let boyfriend_fit_warning = document.getElementById('boyfriend-fit-warning');
  let scrunch_butt_warning = document.getElementById('scrunch-butt-warning');
  let disabled_add_to_cart = document.getElementById('disabled-add-to-cart');
  let add_to_cart = document.getElementById('add-to-cart');

  mens_mesh_warning.style.display = "none";
  athletic_fit_warning.style.display = "none";
  womens_mesh_warning.style.display = "none";
  boyfriend_fit_warning.style.display = "none";
  disabled_add_to_cart.style.display = "none";
  add_to_cart.style.display = "none";

  for(let i = 0; i < tags.length; i++) {
    switch(tags[i]) {
      case 'disclaimer:MENS MESH DISCLAIMER':
        mens_mesh_warning.style.display = "block";
        break;
      case 'ATHLETIC NOTE':
        athletic_fit_warning.style.display = "block";
        break;
      case 'disclaimer:WOMENS MESH DISCLAIMER':
        womens_mesh_warning.style.display = "block";
        break;
      case 'disclaimer:BOYFRIEND FIT':
        boyfriend_fit_warning.style.display = "block";
        break;
      case 'disclaimer:SCRUNCH BUTT':
        scrunch_butt_warning.style.display = "block";
        break;
      case 'promo:APP EXCLUSIVE':
        let app_exclusive_badge = document.createElement('div');
        app_exclusive_badge.classList.add('product_tags');
        app_exclusive_badge.classList.add('product_tag_app_exclusive');
        app_exclusive_badge.appendChild(document.createTextNode('APP EXCLUSIVE'));
        tag_container.appendChild(app_exclusive_badge);

        buy_button_text = 'APP EXCLUSIVE - DOWNLOAD THE APP';
        disable_buy = true;
        break;
      case 'promo:FINAL SALE':
      case 'OUTLET':
        /*let b1g1_badge = document.createElement('div');
        b1g1_badge.classList.add('product_tags');
        b1g1_badge.classList.add('product_tag_bogo');
        b1g1_badge.appendChild(document.createTextNode('BUY 1 GET 1 FREE'));
        tag_container.appendChild(b1g1_badge);*/

        let final_sale_badge = document.createElement('div');
        final_sale_badge.classList.add('product_tags');
        final_sale_badge.classList.add('product_tag_final_sale');
        final_sale_badge.appendChild(document.createTextNode('FINAL SALE'));
        tag_container.appendChild(final_sale_badge);
        break;
      case 'NEW RELEASES':
        let new_tag = document.createElement('div');
        new_tag.classList.add('animated_firenew_tag_container');
        new_tag.classList.add('productTagOnProductPageUnderTitle');

        let fire_new_static = document.createElement('div');
        fire_new_static.classList.add('product_tags');
        fire_new_static.classList.add('product_tag_firenew_static');
        fire_new_static.appendChild(document.createTextNode('NEW'));

        new_tag.appendChild(fire_new_static);

        tag_container.appendChild(new_tag);
        break;
      case 'promo:COMING SOON':
        let coming_soon_badge = document.createElement('div');
        coming_soon_badge.classList.add('product_tags');
        coming_soon_badge.classList.add('product_tag_app_exclusive');
        coming_soon_badge.appendChild(document.createTextNode('COMING SOON'));
        tag_container.appendChild(coming_soon_badge);
        
        buy_button_text = 'Coming Soon - April 5th 12:00 PM';
        disable_buy = true;

        notify_me.style.display = 'block';
        break;
      default:
    }
  }

  // update buy button / messaging
  if(disable_buy) {
    let app_exclusive_mobile = document.getElementById('app-exclusive-mobile');
    let app_exclusive_desktop = document.getElementById('app-exclusive-desktop');
    
    while(app_exclusive_mobile.firstChild) {
      app_exclusive_mobile.removeChild(app_exclusive_mobile.firstChild);
    }
    
    while(app_exclusive_desktop.firstChild) {
      app_exclusive_desktop.removeChild(app_exclusive_desktop.firstChild);
    }

    app_exclusive_mobile.appendChild(document.createTextNode(buy_button_text));
    app_exclusive_desktop.appendChild(document.createTextNode(buy_button_text));
    disabled_add_to_cart.style.display = 'block';
  } else {
    add_to_cart.style.display = 'block';
  }

  if(!available) {
    add_to_cart.style.display = 'none';
  }

  // update color name
  let colorName = document.getElementById('color-name');
  while(colorName.firstChild) {
    colorName.removeChild(colorName.firstChild);
  }
  colorName.appendChild(document.createTextNode(variant.options[0].values[0]));

  // update product prices
  let priceContainer = document.getElementById('tlf_product_price_container');
  while(priceContainer.firstChild) {
    priceContainer.removeChild(priceContainer.firstChild);
  }

  let productPrice = document.createElement('div');
  productPrice.classList.add('tlf-product-price');
  priceContainer.appendChild(productPrice);
  productPrice.appendChild(document.createTextNode('$'+(variant.price/100).toFixed(2)+' USD'));
  if(variant.compare_at_price > 0 && variant.compare_at_price > variant.price) {
    let comparePrice = document.createElement('div');
    comparePrice.classList.add('tlf-product-compare-price');
    productPrice.classList.add('tlf-product-price-discounted');
    comparePrice.appendChild(document.createTextNode('$'+(variant.compare_at_price/100).toFixed(2)+' USD'));
    priceContainer.appendChild(comparePrice);
  }

  // update description
  let description = document.getElementById('tlf-accordian-mobile1');
  description.children[0].innerHTML = variant.description;

  // update hero and thumbs
  let heroContainer = document.getElementById('tlf-hero-container');
  let thumbContainer = document.getElementById('tlf-thumb-container');
  let heroImages = [];
  let thumbImages = [];
  let allMedia = variant.media;

  heroContainer.style.height =  heroContainer.offsetHeight + 'px';
  heroContainer.style.width =  heroContainer.offsetWidth + 'px';
  thumbContainer.style.height =  thumbContainer.offsetHeight + 'px';
  thumbContainer.style.width =  thumbContainer.offsetWidth + 'px';

  let oldHeros = heroContainer.children;
  for(let i =0; i < oldHeros.length; i++){
    oldHeros[i].classList.add('delete-old-hero');
    delete oldHeros[i].dataset.index;
    if(oldHeros[i].classList.contains('active-hero')) {
      oldHeros[i].classList.toggle('active-hero');
      oldHeros[i].classList.add('disabled-hero');
    }
  }

  for (let i = 0; i < allMedia.length; i++) {
    if (allMedia[i].media_type.includes('video')) {
      continue;
    }

    if(allMedia[i].alt && (allMedia[i].alt.includes('vimeo') || allMedia[i].alt.includes('mp4') )) {
      let heroNode = document.createElement('video');
      heroNode.autoplay = false;
      heroNode.muted = true;
      heroNode.loop = true;
      heroNode.setAttribute('playsinline', null);
      heroNode.src = allMedia[i].alt;
      heroNode.dataset.videoType = 'mute';
      heroNode.dataset.videoStyle = 'mute';
      heroNode.dataset.index = i;
      heroNode.classList.add('product__video');
      i == 0 ? heroNode.classList.add('active-hero'): heroNode.classList.add('disabled-hero');
      heroNode.classList.add('hero-image');
      heroNode.setAttribute('preload', 'none');
      heroContainer.appendChild(heroNode);
    } else {
      let heroNode = document.createElement('img');
      i == 0 ? heroNode.classList.add('active-hero'): heroNode.classList.add('disabled-hero');
      heroNode.classList.add('hero-image');
      heroNode.src = allMedia[i].src + '&width=900';
      heroNode.width = '900';
      heroNode.dataset.index = i;
      if (i >= 1) heroNode.setAttribute('loading', 'lazy');
      heroNode.addEventListener('click', () => {fullSizeMedia(heroNode)}, false);
      heroContainer.appendChild(heroNode);
    }

    let thumbImageContainer = document.createElement('div');
    let thumbNode = document.createElement('img');
    if(i == 0) {
      thumbNode.classList.add('active-thumb');
    }
    thumbImageContainer.classList.add('thumb-image');
    thumbNode.src = allMedia[i].src + '&width=146';
    thumbNode.width = '146';
    thumbNode.dataset.index = i;
    let thisThumbnode = thumbNode;
    thumbNode.addEventListener('click', () => {makeHeroImage(thisThumbnode)}, false);
    if(thumbImages.length > 5) thumbNode.setAttribute('loading', 'lazy');

    thumbImageContainer.appendChild(thumbNode);

    if(allMedia[i].alt && (allMedia[i].alt.includes('vimeo') || allMedia[i].alt.includes('mp4'))) {
      let playButton = document.createElement('div');
      playButton.classList.add('playButton');
      thumbImageContainer.appendChild(playButton);
    }

    thumbImages.push(thumbImageContainer);
  }

  while(thumbContainer.firstChild) {
    thumbContainer.removeChild(thumbContainer.firstChild);
  }

  for(i in thumbImages) {
    thumbContainer.appendChild(thumbImages[i]);
  }

  // update size buttons
  let sizeVariantsContainer = document.getElementById('tlf-size-variants-container');
  let newSizes = [];
  let allSizes = variant.variants;

  for(let i = 0; i < allSizes.length; i++) {
    let sizeNode = document.createElement('div');
    sizeNode.classList.add('tlf-product-size-variant');
    sizeNode.dataset.variantid = allSizes[i].id;
    sizeNode.name = allSizes[i].name;
    sizeNode.appendChild(document.createTextNode(allSizes[i].option2));

    if(allSizes[i].available && !disable_buy) {
      sizeNode.addEventListener('click', () => {selectSize(sizeNode)}, false);
    } else {
      sizeNode.classList.add('size-disabled');
    }

    newSizes.push(sizeNode);
  }

  while(sizeVariantsContainer.firstChild) {
    sizeVariantsContainer.removeChild(sizeVariantsContainer.firstChild);
  }

  for (i in newSizes) {
    sizeVariantsContainer.appendChild(newSizes[i]);
  }

  let cartButton = document.getElementById('add-to-cart');
  if(cartButton.classList.contains('active')){
    cartButton.classList.toggle('active');
    cartButton.classList.add('cart-disabled');
    cartButton.innerHTML = 'Select A Size';
    // event listener gets added everytime the user changes variants adding multiple items to cart 
    // cloning removes all event listeners 
    cartButton.replaceWith(cartButton.cloneNode(true));
  }

  setTimeout(() => {
    let deleteHeros = document.getElementsByClassName('delete-old-hero');
    while(deleteHeros[0]){
      deleteHeros[0].parentNode.removeChild(deleteHeros[0]);
    }

    heroContainer.style.height = 'auto';
    heroContainer.style.width = 'auto';  
    thumbContainer.style.height = 'auto';
    thumbContainer.style.width = 'auto';
  }, 8000);

  // fetch associated bundles
  document.getElementById('bundle-swatches-container').style.display = 'none';
  let bundleSwatchContainer = document.getElementById('bundle-swatches');
  while(bundleSwatchContainer.firstChild) {
    bundleSwatchContainer.removeChild(bundleSwatchContainer.firstChild);
  }

  (async () => {
    fetch('https://tlfapparel.myshopify.com/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': '74b04c14043788de101005846d4afafb'
      },
      body: `
      {
        productByHandle(handle: "${variant.handle}") {
          bundleSwatch: metafield(namespace: "Products", key: "bundle_swatch_string") {
            value
            type
          }
        }
      }
    `
    }).then(response => response.json())
    .then(async data => {
      if(data.data.productByHandle && data.data.productByHandle.hasOwnProperty("bundleSwatch") && data.data.productByHandle.bundleSwatch) {
        let bundleSwatch = JSON.parse(data.data.productByHandle.bundleSwatch.value);

        upsellBundle(bundleSwatch);
      }
    });
  })();
}

function makeHeroImage(event) {
  let heroImageIndex = event.dataset.index;
  let activeHero = document.getElementsByClassName('active-hero');

  for(let i = 0; i < activeHero.length; i++) {
    if(activeHero[i].classList.contains('active-hero')) {
      activeHero[i].classList.toggle('disabled-hero');
      activeHero[i].classList.toggle('active-hero');
    }
  }

  let newHero = document.querySelector('.hero-image[data-index="' + heroImageIndex + '"]');
  newHero.classList.toggle('active-hero');
  newHero.classList.toggle('disabled-hero');

  if (newHero.tagName === 'VIDEO') {
    newHero.play();
  }

  let elements = document.getElementsByClassName('active-thumb');

  for (let i = 0; i < elements.length; i++) {
    if(elements[i].classList.contains('active-thumb')) {
      elements[i].classList.remove('active-thumb');
    }
  }

  event.classList.add('active-thumb');
}

function upsellBundle(handles) {
  let queries = [];

  if(typeof handles !== 'undefined') {
    for(i in handles) {
      queries.push(window.Shopify.routes.root+'products/'+handles[i]+'.js');
    }

    try {
      Promise.all(queries.map(u => fetch(u))).then(responses =>
        Promise.allSettled(responses.map(res => {
          return res.json();
        }))
      ).then(data => {
        let bundles = [];

        for(i in data) {
          if(data[i].status == 'fulfilled') {
            bundles.push(data[i].value);
          }
        }

        addBundleSwatches(bundles);
      });
    } catch {
      throw Error("query for associated bundle failed");
    }
  }
}

function addBundleSwatches(bundles) {
  let bundleContainer = document.getElementById('bundle-swatches-container');
  let bundleSwatchContainer = document.getElementById('bundle-swatches');
  let showBundles = false;

  bundles.forEach((value) => {
    if(value.options[0].name === 'Bundle') {
      let wrapper = document.createElement('div');
      let bundleSwatch = document.createElement('img');
      wrapper.classList.add('tlf-color-swatch-wrapper');

      bundleSwatch.src = `https://cdn.shopify.com/s/files/1/2665/0346/files/${value.handle}.jpg`;
      bundleSwatch.alt = value.options[0].values[0];
      bundleSwatch.classList.add('tlf-color-swatch');

      bundleSwatch.addEventListener('click', async () => {
        location.href = value.url;
      });

      wrapper.appendChild(bundleSwatch);
      bundleSwatchContainer.appendChild(wrapper);
      showBundles = true;
    }
  });

  if(showBundles) bundleContainer.style.display = 'block';
}

function addColorVariantSwatches(colorVariants) {
  if(bundleHandles) {
    upsellBundle(bundleHandles);
  }

  document.getElementById("tlf-product-color-variants").style.display = 'none';
  let parentNode = document.getElementById("tlf-color-variant-swatches");

  while(parentNode.firstChild) {
    parentNode.removeChild(parentNode.firstChild);
  }

  colorVariants.forEach((value, index) => {
    if(value.options[0].name === 'Color') {
      let wrapper = document.createElement('div');
      // let colorVariantNode = document.createElement('div');
      wrapper.classList.add('tlf-color-swatch-wrapper');
      // colorVariantNode.classList.add(`tlf-color-${value.options[0].values[0].toLowerCase().replaceAll(' ', '-')}`);
      // colorVariantNode.classList.add('tlf-color-swatch');

      if(value.id === initialProductId) {
        wrapper.classList.add('tlf-color-swatch-wrapper-active');
      }

      let colorVariantNode = document.createElement('img');
      colorVariantNode.src = `https://cdn.shopify.com/s/files/1/2665/0346/files/${value.handle}.jpg`;
      colorVariantNode.alt = value.options[0].values[0];
      colorVariantNode.classList.add('tlf-color-swatch');

      colorVariantNode.addEventListener('click', () => {
        let thisColorVariant = wrapper;
        let color = value;
        let url = color.url;

        let activeColor = document.getElementsByClassName('tlf-color-swatch-wrapper-active');
        for(let i = 0; i < activeColor.length; i++) {
          if(activeColor[i].classList.contains('tlf-color-swatch-wrapper-active')) {
            activeColor[i].classList.toggle('tlf-color-swatch-wrapper-active');
          }
        }

        thisColorVariant.classList.add('tlf-color-swatch-wrapper-active');
        history.pushState({}, null, url);
        updateProductPageState(color);
      });

      wrapper.appendChild(colorVariantNode);
      parentNode.appendChild(wrapper);
    }

    addEventListener("popstate", (event) => {
      let variantColor = value;

      if(variantColor.url.includes(window.location.pathname)) {
        let activeColor = document.getElementsByClassName('tlf-color-swatch-wrapper-active');
        for(let i = 0; i < activeColor.length; i++) {
          if(activeColor[i].classList.contains('tlf-color-swatch-wrapper-active')) {
            activeColor[i].classList.toggle('tlf-color-swatch-wrapper-active');
          }
        }

        let newColor = document.getElementsByClassName(`tlf-color-${variantColor.options[0].values[0].toLowerCase().replaceAll(' ', '-')}`);

        if(newColor[0]) {
          newColor[0].parentNode.classList.add('tlf-color-swatch-wrapper-active');
          updateProductPageState(variantColor);
        }
      }
    });
  });
}

function selectSize(event) {
  let allSizes = document.getElementsByClassName('tlf-product-size-variant');
  for(let i = 0; i < allSizes.length; i++) {
    if(allSizes[i].classList.contains('active-size')) {
      allSizes[i].classList.toggle('active-size');
    }
  }

  event.classList.add('active-size');
  let cartButton = document.getElementById('add-to-cart');
  
  if(!cartButton.classList.contains('active')) {
    cartButton.classList.toggle('cart-disabled');
    cartButton.innerHTML = 'Add To Bag';
    cartButton.addEventListener('click', () => {
      let sizes = document.getElementsByClassName('active-size');

 
      
  // ALGOLIA
  if(document.referrer.includes("/collections/")){
  
    try{
     
      aa('init', {
        appId: "35RQENUZNB",
        apiKey: "b7c2503191bc928ac947acc0b5815029",
        useCookie: true
      })
    
      aa('getUserToken', null, (err, userToken) => {
        if (err) {
          console.error(err);
          return;
        }
        // window.aa('viewedObjectIDs', {
        //   'eventType': 'view',
        //   'eventName': 'Test View Event',
        //   'index': 'TestIndex',
        //   'objectIDs': ['test-object']
        // })
        aa('convertedObjectIDsAfterSearch', {
          userToken: userToken,
          index: "a_products",
          eventName: "convertedObjectIDsAfterSearch",
          queryID: sessionStorage.getItem("queryID"),
          objectIDs: [sizes[0].dataset.variantid],
          
      });
      });
    }
    catch(e){
      console.log(e)
    }
  }
  else {
    try {
     
      aa('init', {
        appId: "35RQENUZNB",
        apiKey: "b7c2503191bc928ac947acc0b5815029",
        useCookie: true
      })
    
      aa('getUserToken', null, (err, userToken) => {
        if (err) {
          console.error(err);
          return;
        }
        aa('convertedObjectIDs', {
          userToken: userToken,
          index: "a_products",
          eventName: "convertedObjectIDs",
          objectIDs: [sizes[0].dataset.variantid],             
        });
      });
    }
    catch (e) {
      console.log(e)
    }
  }
  // END ALGOLIA

      var _learnq = _learnq || [];

      formData.items.push({
        id: sizes[0].dataset.variantid,
        quantity: 1
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response =>  response.clone().json())
      .then(data => {
        formData.items = [];

        var cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items
        }

        if(item !== 'undefined') {
          cart = Object.assign(cart, item);
        }

        _learnq.push(['track', 'Added to Cart Reclaim', cart]);
        geq.addToCart(item);
      }).catch((error) => {
        console.error('Error:', error);
      });
    });
  
    cartButton.classList.add('active');
  }
}

function toggleAccordian(element) {
  let panel = document.getElementById(element);

  if(panel.style.display === "block") {
    panel.style.display = "none";
  } else {
    panel.style.display = "block";
  }
}

function fullSizeMedia(element) {
  if(element.tagName === 'IMG') {
    let closeButton = document.createElement('div');
    closeButton.classList.add('close-full-size');
    closeButton.addEventListener('click', () => {
      let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
      while(deleteFullSizeContainer[0]){
        deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
      }
    });

    closeButton.appendChild(document.createTextNode('X'));
    let fullSizeContainer = document.createElement('div');
    fullSizeContainer.classList.add('full-size-container');
    fullSizeContainer.addEventListener('click', () => {
      let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
      while(deleteFullSizeContainer[0]){
        deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
      }
    });

    let fullSize = document.createElement('img');
    fullSize.classList.add('full-size-img');
    fullSize.src = element.src.replace('&width=1200', '');
    fullSizeContainer.appendChild(closeButton);
    fullSizeContainer.appendChild(fullSize);
    document.body.appendChild(fullSizeContainer);
  } else if (element.tagName === 'VIDEO') {
    element.controls = true;
  }
}

function sizeCharts(productId){
  let sizeChartButton = document.getElementById('tlf-size-chart');

  fetch(`https://tlf-server-2023-oxh3p.ondigitalocean.app/size-charts/product/${productId}`)
  .then((data) => data.json())
  .then((response) => {

    if(response.length > 0) {
      sizeChartButton.style.display = 'block';
      sizeChartButton.addEventListener('click', () => {
        let closeButton = document.createElement('div');
        closeButton.classList.add('close-full-size');
        closeButton.addEventListener('click', () => {
          let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
          while(deleteFullSizeContainer[0]){
            deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
          }
        });
  
        closeButton.appendChild(document.createTextNode('X'));
        let fullSizeContainer = document.createElement('div');
        fullSizeContainer.classList.add('full-size-container');
        fullSizeContainer.addEventListener('click', () => {
          let deleteFullSizeContainer = document.getElementsByClassName('full-size-container');
          while(deleteFullSizeContainer[0]){
            deleteFullSizeContainer[0].parentNode.removeChild(deleteFullSizeContainer[0]);
          }
        });

        let chart = document.createElement('div');
        chart.classList.add('size-chart-container');

        response.forEach((product, index) => {
          let tableName = document.createElement('div');
          tableName.appendChild(document.createTextNode(product.title));

          let inches = document.createElement('div');
          inches.classList.add('inches');
          inches.classList.add('selected-measurement');
          inches.appendChild(document.createTextNode('in'));

          let centimeters = document.createElement('div');
          centimeters.classList.add('centimeters');
          centimeters.appendChild(document.createTextNode('cm'));

          let toggleMeasurements = document.createElement('div');
          toggleMeasurements.classList.add('measurement-container');
          toggleMeasurements.appendChild(inches);
          toggleMeasurements.appendChild(centimeters);
          toggleMeasurements.addEventListener('click', (event) => {
            event.stopPropagation();
    
            if (!event.target.classList.toString().includes('selected-measurement')){
              let formula;
              if (event.target.classList.toString().includes('inches')){
                // n/2.54
                formula = (value) => {
                  return (Number(value) / 2.54).toFixed(2);
                };
              } else if (event.target.classList.toString().includes('centimeters')){
                // 2.54*n
                formula = (value) => {
                  return (2.54 * Number(value)).toFixed(2);
                }
              }

              for(const child of event.target.parentNode.children){
                child.classList.toggle('selected-measurement');
              }

              let tables = document.querySelectorAll('.table-wrap table');

              if(tables.length > 0){
                tables.forEach((item) => {
                  for(let i = 0; i < item.rows.length; i++){
                    for(let j = 0; j < item.rows[i].cells.length; j++){
                      let cellData = item.rows[i].cells[j].childNodes[0].data;

                      if(!cellData.trim().length){
                        continue;
                      }

                      if(cellData.search(/[A-Za-z]+/gm) === -1){
                        if(cellData.includes('-')){
                          if (cellData.length == 1){
                            continue;
                          }
                          let numericValues = cellData.replaceAll(" ", "").split('-');
                          item.rows[i].cells[j].childNodes[0].data = Number(formula(numericValues[0])) + ' - ' + Number(formula(numericValues[1]));
                        } else if(cellData.includes('/')){
                          let numericValues = cellData.split(" ");
                          let fraction = numericValues[1].split('/');
                          let decimal = Number(numericValues[0]) + (Number(fraction[0]) / Number(fraction[1]));
                          item.rows[i].cells[j].childNodes[0].data = Number(formula(decimal));
                        } else {
                          item.rows[i].cells[j].childNodes[0].data = Number(formula(cellData));
                        }
                      }
                    }
                  }
                });
              }
            }
          });

          tableName.classList.add('size-chart-name');
          chart.appendChild(tableName);
          chart.appendChild(toggleMeasurements);

          if(product.hasOwnProperty('table1')){
            chart.appendChild(createTable(product.table1));
          }
          if(product.hasOwnProperty('table2')){
            chart.appendChild(createTable(product.table2));
          }
          if(product.hasOwnProperty('table3')){
            chart.appendChild(createTable(product.table3));
          }
          if(product.hasOwnProperty('table4')){
            chart.appendChild(createTable(product.table));
          }
          if(product.hasOwnProperty('table5')){
            chart.appendChild(createTable(product.table5));
          }
        });

        let containerWrap = document.createElement('div');
        containerWrap.classList.add('full-size-container-wrap');

        containerWrap.appendChild(closeButton);
        containerWrap.appendChild(chart);
        fullSizeContainer.appendChild(containerWrap);
        document.body.appendChild(fullSizeContainer);

      });
    } else {
      sizeChartButton.style.display = 'none';
      sizeChartButton.removeAttribute('onclick');
    }
  });
}

 function createTable(tableData){
  let table = document.createElement('table');

  for(let i = 0; i < tableData.length; i++){
    let tr = table.insertRow();

    for(let j = 0; j < tableData[i].length; j++){
      let td = tr.insertCell();
      td.appendChild(document.createTextNode(tableData[i][j]));
    }
  }

  table.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  let tableWrap = document.createElement('div');
  tableWrap.classList.add('table-wrap');
  tableWrap.appendChild(table);

  return tableWrap;
 }